import React from 'react';
import classNameBind from 'classnames/bind';
import Tabs from '../../../Tabs';
import Caption from '../../../Caption';
import Tooltip from '../../../Tooltip';
import Icon from '../../../Icon';
import Stack from '../../../Stack';
import uuid from '../../../../utils/methods/uuid';
import styles from './ViewHeader.module.css';
import CopyIcon from '../CopyIcon';

const bindClasses = classNameBind.bind(styles);

const ViewHeader = ({
  title,
  caption,
  captionCopyValue,
  children,
  helpIcon,
  inlineElements,
  tabs,
  sticky,
  RouterLink,
  location,
} = {}) => {
  const arrayOfChildren = React.Children.toArray(children);
  let helpIcons = helpIcon.icon ? [helpIcon] : helpIcon;
  helpIcons = helpIcons.length ? helpIcons : [];

  return (
    <div
      className={bindClasses('wrapper', { sticky })}
      data-ppuc-id="ViewHeader"
    >
      <Stack spacing="narrow" verticalAlignment="center">
        <Stack.Item fill>
          <Stack spacing="extraNarrow" vertical>
            {location.length > 0 && (
            <div data-ppuc-id="ViewHeader.location" className={bindClasses('location')}>
              {location.map((item, index) => (
                <React.Fragment key={index}>
                  {index !== 0 && <span className={bindClasses('divider')}>/</span>}
                  {item}
                </React.Fragment>
              ))}
            </div>
            )}

            {title && (
              <div className={bindClasses('flex')}>
                <div className={bindClasses('flex-cut-text')}>
                  <Tooltip content={title}>
                    <div
                      className={bindClasses('title')}
                      data-ppuc-id="ViewHeader.title"
                    >
                      {title}
                    </div>
                  </Tooltip>
                </div>
                <div className={bindClasses('flex-full-width')}>
                  {helpIcons.map((icon, index) => (
                    <span className={bindClasses('icon', { onClick: !!icon.onClick })} key={index}>
                      <Tooltip content={icon.text} title={icon.title}>
                        <span
                          role="button"
                          tabIndex={0}
                          onClick={() => { if (icon.onClick) icon.onClick(icon); }}
                          className={bindClasses({ swapIconOnHover: !!icon.swapIconOnHover })}
                        >
                          <Icon name={icon.icon} color={icon.color} />
                          {icon.swapIconOnHover && <Icon name={icon.swapIconOnHover} color={icon.color} />}
                        </span>
                      </Tooltip>
                    </span>
                  ))}
                  {
                    inlineElements.map((el, index) => (
                      <span className={bindClasses('inline-element')} key={`el-${index}`}>
                        {el}
                      </span>
                    ))
                  }
                </div>
              </div>
            )}
            {caption && (
              <div className={bindClasses('caption-wrapper')}>
                {typeof caption === 'string' ? (
                  <Caption subdued dataId="ViewHeader.caption">
                    {caption}
                  </Caption>
                )
                  : caption
                }
                {captionCopyValue && (
                  <div className={bindClasses('copy-icon')}>
                    <CopyIcon value={captionCopyValue} />
                  </div>
                )}
              </div>
            )}
          </Stack>
        </Stack.Item>
        {arrayOfChildren.map(child => (
          <Stack.Item key={uuid()}>
            {child}
          </Stack.Item>
        ))}
      </Stack>
      {tabs && (
        <div className={bindClasses('tabs')}>
          <Tabs {...{ tabs }} RouterLink={RouterLink} withoutBorderBottom={sticky} />
        </div>
      )}
    </div>
  );
};

ViewHeader.defaultProps = {
  children: null,
  caption: null,
  captionCopyValue: '',
  helpIcon: [],
  tabs: null,
  sticky: false,
  RouterLink: null,
  inlineElements: [],
  location: [],
};

ViewHeader.displayName = 'View.Header';

export default ViewHeader;
